export const faqData = [
  {
    question: "What requirements are needed before I apply for a badge ?",
    answer:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Eros, mi ultricies integer erat dictum. Nunc ultrices sit justo bibendum nibh. Eget sed in egestas accumsan sit porta.",
  },
  {
    question: "What requirements are needed before I apply for a badge ?",
    answer:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Eros, mi ultricies integer erat dictum. Nunc ultrices sit justo bibendum nibh. Eget sed in egestas accumsan sit porta.",
  },
  {
    question: "What requirements are needed before I apply for a badge ?",
    answer:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Eros, mi ultricies integer erat dictum. Nunc ultrices sit justo bibendum nibh. Eget sed in egestas accumsan sit porta.",
  },
];
